import { combineReducers } from 'redux';
import components from './ltd';

export const ltd = combineReducers({
    components
});
